<template>
	<sf-card :title="getMessage_('QWCC001745')">
		<sf-data-table
			ref="grpTable"
			index
			height="350px"
			:paging="false"
			:excel="isButton_(scrId, 'EX')"
			:columns="cols"
			:rows="rows"
			:stripe="false"
			:selection="false"
		>
		</sf-data-table>
	</sf-card>
</template>

<script>
import { rootComputed } from '@/store/common/helpers'; //공통
import { serviceComputed, serviceMethods } from '@mqy/clma/PcPcm/store/helpers';

export default {
	props: {
		scrId: { type: String, default: '' }
	},
	data() {
		return {};
	},
	created() {},
	computed: {
		...rootComputed,
		...serviceComputed,
		rows() {
			return this.lpList;
		},
		cols() {
			return this.LpCols_;
		}
	},
	methods: {
		...serviceMethods,
		resetTable() {
			this.$emit('Refresh');
		}
	}
};
</script>

<style></style>
